import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { IProductoData } from '@core/interfaces/entidades/producto.entidad';

@Component({
  selector: 'app-ver-producto',
  imports: [],
  templateUrl: './ver-producto.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './ver-producto.css',
})
export class VerProducto {
  producto = input.required<IProductoData>();

  cerrar = output<void>();
  onCerrar() {
    this.cerrar.emit();
  }
}
